export default __webpack_public_path__ + "back.svg";